import { defineMessages } from '@/i18n'

/** AU's Mobile users page: Flutter-app logins (workers / workers_login). */
export const mobileUsersMessages = defineMessages({
  en: {
    title: 'Mobile users',
    intro: 'Accounts for the MIH crew app. The same people AU lists under Mobile users.',
    search: 'Search name, username, number, employee',
    titleAll: 'All',
    titleWorker: 'Worker',
    titleEmployee: 'Employee',
    titleTranslation: 'Translation only',
    titleBauleiter: 'Bauleiter',
    titleManager: 'Manager',
    titleStorage: 'Storage manager',
    titleCeo: 'CEO',
    titleBigCeo: 'Big CEO',
    titleKolona: 'Kolona leader',
    colUser: 'Name',
    colNumber: 'Number',
    colTitle: 'Title',
    colPhone: 'Phone',
    colCountry: 'Country',
    colEmployee: 'Linked employee',
    colRtk: 'RTK login',
    colApp: 'App version',
    asphalt: 'Asphalt',
    active: 'Can sign in',
    off: 'switched off',
    empty: 'No one matches.',
    loading: 'Loading mobile users…',
    addUser: 'Add user',
    addTranslation: 'Add translation user',
    writesOff: "Creating mobile logins isn't set up on this server yet.",
    editUser: 'Edit mobile user',
    newUser: 'New mobile user',
    newTranslation: 'New translation user',
    translationHint: 'Links to AU employee TRAN-01. Username is built from the name; the password is shown once.',
    createHint: 'Creates the login the crew app uses. The password is generated and shown once.',
    firstName: 'First name',
    lastName: 'Last name',
    username: 'Username',
    usernameHint: 'What they type in the crew app.',
    email: 'Email',
    workTitle: 'Work title',
    personalNumber: 'Personal number',
    country: 'Work country',
    employee: 'Employee link',
    pickEmployee: 'Search AU staff…',
    position: 'User position',
    rtkLogin: 'RTK login',
    rtkNone: 'None',
    lidar: 'Can use lidar in the mobile app',
    sendVideo: 'Measure sends video',
    canAddCar: 'Can add new cars',
    canAddMachine: 'Can add new machines',
    asphaltBl: 'Asphalt BL',
    loginInfo: 'Login',
    resetPassword: 'New password',
    resetConfirm: 'Give {name} a new password? The old one stops working in the crew app.',
    switchOff: 'Switch off',
    switchOn: 'Switch on',
    switchOffConfirm: 'Switch off {name}? They can no longer sign in to the crew app.',
    credentialsTitle: 'Save these details',
    credentialsHint: 'Shown once. They sign in to the MIH app with this username and password.',
    copy: 'Copy',
    copied: 'Copied',
    password: 'Password',
    done: 'Done',
    create: 'Create',
    creating: 'Creating…',
    couldNotSave: 'Could not save.',
    confirm: 'Yes, continue',
    none: 'None',
  },
  de: {
    title: 'Mobile Nutzer',
    intro: 'Konten für die MIH-Kolonnen-App. Dieselbe Liste wie in AU unter Mobile users.',
    search: 'Name, Benutzername, Nummer, Mitarbeiter suchen',
    titleAll: 'Alle',
    titleWorker: 'Arbeiter',
    titleEmployee: 'Angestellter',
    titleTranslation: 'Nur Übersetzung',
    titleBauleiter: 'Bauleiter',
    titleManager: 'Manager',
    titleStorage: 'Lagermanager',
    titleCeo: 'CEO',
    titleBigCeo: 'Big CEO',
    titleKolona: 'Kolonnenführer',
    colUser: 'Name',
    colNumber: 'Nummer',
    colTitle: 'Titel',
    colPhone: 'Telefon',
    colCountry: 'Land',
    colEmployee: 'Verknüpfter Mitarbeiter',
    colRtk: 'RTK-Login',
    colApp: 'App-Version',
    asphalt: 'Asphalt',
    active: 'Anmeldung möglich',
    off: 'deaktiviert',
    empty: 'Niemand passt.',
    loading: 'Mobile Nutzer werden geladen…',
    addUser: 'Nutzer hinzufügen',
    addTranslation: 'Übersetzer hinzufügen',
    writesOff: 'Mobile Logins sind auf diesem Server noch nicht eingerichtet.',
    editUser: 'Mobilen Nutzer bearbeiten',
    newUser: 'Neuer mobiler Nutzer',
    newTranslation: 'Neuer Übersetzer',
    translationHint: 'Verknüpft mit AU-Mitarbeiter TRAN-01. Der Benutzername kommt vom Namen; das Passwort wird einmal angezeigt.',
    createHint: 'Legt den Login für die Kolonnen-App an. Das Passwort wird erzeugt und einmal angezeigt.',
    firstName: 'Vorname',
    lastName: 'Nachname',
    username: 'Benutzername',
    usernameHint: 'Was sie in der Kolonnen-App eingeben.',
    email: 'E-Mail',
    workTitle: 'Funktion',
    personalNumber: 'Personalnummer',
    country: 'Arbeitsland',
    employee: 'Mitarbeiterverknüpfung',
    pickEmployee: 'AU-Personal suchen…',
    position: 'Position',
    rtkLogin: 'RTK-Login',
    rtkNone: 'Keiner',
    lidar: 'LiDAR in der App nutzen',
    sendVideo: 'Messung sendet Video',
    canAddCar: 'Neue Autos anlegen',
    canAddMachine: 'Neue Maschinen anlegen',
    asphaltBl: 'Asphalt-BL',
    loginInfo: 'Anmeldung',
    resetPassword: 'Neues Passwort',
    resetConfirm: '{name} ein neues Passwort geben? Das alte gilt in der App nicht mehr.',
    switchOff: 'Deaktivieren',
    switchOn: 'Aktivieren',
    switchOffConfirm: '{name} deaktivieren? Anmeldung in der Kolonnen-App ist dann nicht mehr möglich.',
    credentialsTitle: 'Diese Daten speichern',
    credentialsHint: 'Wird nur einmal gezeigt. Damit melden sie sich in der MIH-App an.',
    copy: 'Kopieren',
    copied: 'Kopiert',
    password: 'Passwort',
    done: 'Fertig',
    create: 'Anlegen',
    creating: 'Wird angelegt…',
    couldNotSave: 'Speichern fehlgeschlagen.',
    confirm: 'Ja, fortfahren',
    none: 'Keine',
  },
  cnr: {
    title: 'Mobilni korisnici',
    intro: 'Nalozi za MIH aplikaciju kolone. Ista lista kao u AU pod Mobile users.',
    search: 'Pretraga imena, korisničkog imena, broja, zaposlenog',
    titleAll: 'Svi',
    titleWorker: 'Radnik',
    titleEmployee: 'Zaposleni',
    titleTranslation: 'Samo prevođenje',
    titleBauleiter: 'Bauleiter',
    titleManager: 'Menadžer',
    titleStorage: 'Magacioner',
    titleCeo: 'CEO',
    titleBigCeo: 'Big CEO',
    titleKolona: 'Vođa kolone',
    colUser: 'Ime',
    colNumber: 'Broj',
    colTitle: 'Titula',
    colPhone: 'Telefon',
    colCountry: 'Država',
    colEmployee: 'Povezani zaposleni',
    colRtk: 'RTK prijava',
    colApp: 'Verzija aplikacije',
    asphalt: 'Asfalt',
    active: 'Može da se prijavi',
    off: 'isključen',
    empty: 'Niko ne odgovara.',
    loading: 'Učitavanje mobilnih korisnika…',
    addUser: 'Dodaj korisnika',
    addTranslation: 'Dodaj prevodioca',
    writesOff: 'Kreiranje mobilnih prijava još nije podešeno na ovom serveru.',
    editUser: 'Izmijeni mobilnog korisnika',
    newUser: 'Novi mobilni korisnik',
    newTranslation: 'Novi prevodilac',
    translationHint: 'Povezuje se na AU zaposlenog TRAN-01. Korisničko ime se pravi od imena; lozinka se prikaže jednom.',
    createHint: 'Pravi prijavu koju koristi aplikacija kolone. Lozinka se generiše i prikaže jednom.',
    firstName: 'Ime',
    lastName: 'Prezime',
    username: 'Korisničko ime',
    usernameHint: 'Šta unose u aplikaciji kolone.',
    email: 'Email',
    workTitle: 'Radno mjesto',
    personalNumber: 'Lični broj',
    country: 'Zemlja rada',
    employee: 'Veza na zaposlenog',
    pickEmployee: 'Pretraži AU kadar…',
    position: 'Pozicija',
    rtkLogin: 'RTK prijava',
    rtkNone: 'Nijedna',
    lidar: 'Može da koristi lidar u aplikaciji',
    sendVideo: 'Mjerenje šalje video',
    canAddCar: 'Može da dodaje automobile',
    canAddMachine: 'Može da dodaje mašine',
    asphaltBl: 'Asfalt BL',
    loginInfo: 'Prijava',
    resetPassword: 'Nova lozinka',
    resetConfirm: 'Dati {name} novu lozinku? Stara više ne radi u aplikaciji.',
    switchOff: 'Isključi',
    switchOn: 'Uključi',
    switchOffConfirm: 'Isključiti {name}? Više se ne mogu prijaviti u aplikaciju kolone.',
    credentialsTitle: 'Sačuvajte ove podatke',
    credentialsHint: 'Prikazuje se jednom. Time se prijavljuju u MIH aplikaciju.',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    password: 'Lozinka',
    done: 'Gotovo',
    create: 'Kreiraj',
    creating: 'Kreiranje…',
    couldNotSave: 'Nije moguće sačuvati.',
    confirm: 'Da, nastavi',
    none: 'Nijedan',
  },
  bs: {
    title: 'Mobilni korisnici',
    intro: 'Nalozi za MIH aplikaciju kolone. Ista lista kao u AU pod Mobile users.',
    search: 'Pretraga imena, korisničkog imena, broja, zaposlenog',
    titleAll: 'Svi',
    titleWorker: 'Radnik',
    titleEmployee: 'Zaposleni',
    titleTranslation: 'Samo prevođenje',
    titleBauleiter: 'Bauleiter',
    titleManager: 'Menadžer',
    titleStorage: 'Magacioner',
    titleCeo: 'CEO',
    titleBigCeo: 'Big CEO',
    titleKolona: 'Vođa kolone',
    colUser: 'Ime',
    colNumber: 'Broj',
    colTitle: 'Titula',
    colPhone: 'Telefon',
    colCountry: 'Država',
    colEmployee: 'Povezani zaposleni',
    colRtk: 'RTK prijava',
    colApp: 'Verzija aplikacije',
    asphalt: 'Asfalt',
    active: 'Može se prijaviti',
    off: 'isključen',
    empty: 'Niko ne odgovara.',
    loading: 'Učitavanje mobilnih korisnika…',
    addUser: 'Dodaj korisnika',
    addTranslation: 'Dodaj prevodioca',
    writesOff: 'Kreiranje mobilnih prijava još nije podešeno na ovom serveru.',
    editUser: 'Uredi mobilnog korisnika',
    newUser: 'Novi mobilni korisnik',
    newTranslation: 'Novi prevodilac',
    translationHint: 'Povezuje se na AU zaposlenog TRAN-01. Korisničko ime se pravi od imena; lozinka se prikaže jednom.',
    createHint: 'Pravi prijavu koju koristi aplikacija kolone. Lozinka se generiše i prikaže jednom.',
    firstName: 'Ime',
    lastName: 'Prezime',
    username: 'Korisničko ime',
    usernameHint: 'Što unose u aplikaciji kolone.',
    email: 'Email',
    workTitle: 'Radno mjesto',
    personalNumber: 'Osobni broj',
    country: 'Zemlja rada',
    employee: 'Veza na zaposlenog',
    pickEmployee: 'Pretraži AU kadar…',
    position: 'Pozicija',
    rtkLogin: 'RTK prijava',
    rtkNone: 'Nijedna',
    lidar: 'Može koristiti lidar u aplikaciji',
    sendVideo: 'Mjerenje šalje video',
    canAddCar: 'Može dodavati automobile',
    canAddMachine: 'Može dodavati mašine',
    asphaltBl: 'Asfalt BL',
    loginInfo: 'Prijava',
    resetPassword: 'Nova lozinka',
    resetConfirm: 'Dati {name} novu lozinku? Stara više ne radi u aplikaciji.',
    switchOff: 'Isključi',
    switchOn: 'Uključi',
    switchOffConfirm: 'Isključiti {name}? Više se ne mogu prijaviti u aplikaciju kolone.',
    credentialsTitle: 'Sačuvajte ove podatke',
    credentialsHint: 'Prikazuje se jednom. Time se prijavljuju u MIH aplikaciju.',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    password: 'Lozinka',
    done: 'Gotovo',
    create: 'Kreiraj',
    creating: 'Kreiranje…',
    couldNotSave: 'Nije moguće spasiti.',
    confirm: 'Da, nastavi',
    none: 'Nijedan',
  },
  sr: {
    title: 'Mobilni korisnici',
    intro: 'Nalozi za MIH aplikaciju kolone. Ista lista kao u AU pod Mobile users.',
    search: 'Pretraga imena, korisničkog imena, broja, zaposlenog',
    titleAll: 'Svi',
    titleWorker: 'Radnik',
    titleEmployee: 'Zaposleni',
    titleTranslation: 'Samo prevođenje',
    titleBauleiter: 'Bauleiter',
    titleManager: 'Menadžer',
    titleStorage: 'Magacioner',
    titleCeo: 'CEO',
    titleBigCeo: 'Big CEO',
    titleKolona: 'Vođa kolone',
    colUser: 'Ime',
    colNumber: 'Broj',
    colTitle: 'Titula',
    colPhone: 'Telefon',
    colCountry: 'Država',
    colEmployee: 'Povezani zaposleni',
    colRtk: 'RTK prijava',
    colApp: 'Verzija aplikacije',
    asphalt: 'Asfalt',
    active: 'Može da se prijavi',
    off: 'isključen',
    empty: 'Niko ne odgovara.',
    loading: 'Učitavanje mobilnih korisnika…',
    addUser: 'Dodaj korisnika',
    addTranslation: 'Dodaj prevodioca',
    writesOff: 'Kreiranje mobilnih prijava još nije podešeno na ovom serveru.',
    editUser: 'Izmeni mobilnog korisnika',
    newUser: 'Novi mobilni korisnik',
    newTranslation: 'Novi prevodilac',
    translationHint: 'Povezuje se na AU zaposlenog TRAN-01. Korisničko ime se pravi od imena; lozinka se prikaže jednom.',
    createHint: 'Pravi prijavu koju koristi aplikacija kolone. Lozinka se generiše i prikaže jednom.',
    firstName: 'Ime',
    lastName: 'Prezime',
    username: 'Korisničko ime',
    usernameHint: 'Šta unose u aplikaciji kolone.',
    email: 'Email',
    workTitle: 'Radno mesto',
    personalNumber: 'Lični broj',
    country: 'Zemlja rada',
    employee: 'Veza na zaposlenog',
    pickEmployee: 'Pretraži AU kadar…',
    position: 'Pozicija',
    rtkLogin: 'RTK prijava',
    rtkNone: 'Nijedna',
    lidar: 'Može da koristi lidar u aplikaciji',
    sendVideo: 'Merenje šalje video',
    canAddCar: 'Može da dodaje automobile',
    canAddMachine: 'Može da dodaje mašine',
    asphaltBl: 'Asfalt BL',
    loginInfo: 'Prijava',
    resetPassword: 'Nova lozinka',
    resetConfirm: 'Dati {name} novu lozinku? Stara više ne radi u aplikaciji.',
    switchOff: 'Isključi',
    switchOn: 'Uključi',
    switchOffConfirm: 'Isključiti {name}? Više se ne mogu prijaviti u aplikaciju kolone.',
    credentialsTitle: 'Sačuvajte ove podatke',
    credentialsHint: 'Prikazuje se jednom. Time se prijavljuju u MIH aplikaciju.',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    password: 'Lozinka',
    done: 'Gotovo',
    create: 'Kreiraj',
    creating: 'Kreiranje…',
    couldNotSave: 'Nije moguće sačuvati.',
    confirm: 'Da, nastavi',
    none: 'Nijedan',
  },
})
